import { useParams } from 'react-router-dom';
import { MARKET_DOWNLOAD_TIMES, EN_TO_KO_MARKET_NAME_MAP } from './_constants/_consts';

import { TitleSection, DescriptionSection } from './_components/TextSection';
import ConnectionAnimate from './_components/ConnectionAnimate';
import ProgressBar from './_components/ProgressBar';
import { MarketInfoProps } from '@/types/market';
import ControllerSection from './_components/ControllerSection';
import { useRecoilState } from 'recoil';
import { isMobileState } from '@/store/atom';
import { useResponsive } from '@/hooks/useResponsive';

const getMarketDownloadTimes = (marketKey: string) => {
  return MARKET_DOWNLOAD_TIMES[marketKey] || { downloadMin: 10, downloadAnnualMin: 40 };
};

const getKoreanMarketName = (englishMarketName: string) => {
  return EN_TO_KO_MARKET_NAME_MAP[englishMarketName] || '쿠팡';
};

const MarketConnectionCompletePage = () => {
  const [isMobile] = useRecoilState(isMobileState);
  const { englishMarketName } = useParams();
  const { isPCSize } = useResponsive();

  const marketName = getKoreanMarketName(englishMarketName || '');
  const { downloadMin, downloadAnnualMin } = getMarketDownloadTimes(englishMarketName || '');

  const marketProps: MarketInfoProps = {
    marketName,
    downloadMin,
    downloadAnnualMin,
  };

  return (
    <div className="flex w-full flex-1 items-center justify-center">
      <div
        className={`flex h-[100dvh] w-full max-w-[850px] flex-col items-center justify-center bg-white 
             px-[20px] lg:h-[516px] lg:flex-1 lg:rounded-md lg:border ${
               isMobile ? 'py-0' : 'pb-[32px] pt-[36px]'
             }`}
      >
        <article
          className={`flex w-full flex-1 flex-col items-center ${
            isPCSize ? 'justify-start' : 'justify-start '
          }`}
        >
          {!isPCSize && <div className="h-[15%]" />}

          <ConnectionAnimate isPcSize={!isMobile} />
          <article className="flex w-full flex-col items-center gap-[24px] pt-[16px] ">
            {/* englishMarketName 전달 */}
            <TitleSection {...marketProps} englishMarketName={englishMarketName} />

            <ProgressBar englishMarketName={englishMarketName} />
          </article>

          {/* englishMarketName 전달 */}
          <DescriptionSection {...marketProps} englishMarketName={englishMarketName} />
        </article>

        <ControllerSection />
      </div>
    </div>
  );
};

export default MarketConnectionCompletePage;
